import { atom } from "recoil";
import { Session } from "./types";

export const sessionState = atom<Session>({
  key: "session_state",
  default: { utm: {} }
});
